"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  addTranslations: true,
  setTranslator: true,
  tr: true,
  stringExists: true,
  setTranslateVariableRegex: true,
  setTranslateReferenceRegex: true,
  processOptions: true,
  objectTraverse: true,
  setLanguageByName: true,
  addLanguageTranslations: true,
  trModel: true,
  trField: true,
  trError: true,
  trPath: true,
  trPathSetBase: true,
  createSchema: true,
  AutoformBase: true
};
Object.defineProperty(exports, "addTranslations", {
  enumerable: true,
  get: function () {
    return _translate.addTranslations;
  }
});
Object.defineProperty(exports, "setTranslator", {
  enumerable: true,
  get: function () {
    return _translate.setTranslator;
  }
});
Object.defineProperty(exports, "tr", {
  enumerable: true,
  get: function () {
    return _translate.tr;
  }
});
Object.defineProperty(exports, "stringExists", {
  enumerable: true,
  get: function () {
    return _translate.stringExists;
  }
});
Object.defineProperty(exports, "setTranslateVariableRegex", {
  enumerable: true,
  get: function () {
    return _translate.setTranslateVariableRegex;
  }
});
Object.defineProperty(exports, "setTranslateReferenceRegex", {
  enumerable: true,
  get: function () {
    return _translate.setTranslateReferenceRegex;
  }
});
Object.defineProperty(exports, "processOptions", {
  enumerable: true,
  get: function () {
    return _utils.processOptions;
  }
});
Object.defineProperty(exports, "objectTraverse", {
  enumerable: true,
  get: function () {
    return _utils.objectTraverse;
  }
});
Object.defineProperty(exports, "setLanguageByName", {
  enumerable: true,
  get: function () {
    return _translation_utils.setLanguageByName;
  }
});
Object.defineProperty(exports, "addLanguageTranslations", {
  enumerable: true,
  get: function () {
    return _translation_utils.addLanguageTranslations;
  }
});
Object.defineProperty(exports, "trModel", {
  enumerable: true,
  get: function () {
    return _translation_utils.trModel;
  }
});
Object.defineProperty(exports, "trField", {
  enumerable: true,
  get: function () {
    return _translation_utils.trField;
  }
});
Object.defineProperty(exports, "trError", {
  enumerable: true,
  get: function () {
    return _translation_utils.trError;
  }
});
Object.defineProperty(exports, "trPath", {
  enumerable: true,
  get: function () {
    return _translation_utils.trPath;
  }
});
Object.defineProperty(exports, "trPathSetBase", {
  enumerable: true,
  get: function () {
    return _translation_utils.trPathSetBase;
  }
});
Object.defineProperty(exports, "createSchema", {
  enumerable: true,
  get: function () {
    return _createSchema.createSchema;
  }
});
Object.defineProperty(exports, "AutoformBase", {
  enumerable: true,
  get: function () {
    return _AutoformBase.AutoformBase;
  }
});

var _translate = require("./translate");

var _utils = require("./utils");

var _translation_utils = require("./translation_utils");

var _createSchema = require("./createSchema");

var _AutoformBase = require("./ui/AutoformBase");

var _componentRender = require("./ui/componentRender");

Object.keys(_componentRender).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _componentRender[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _componentRender[key];
    }
  });
});